// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// app/javascript/application.js
import { application } from "./controllers/application"
import Dropdown from '@stimulus-components/dropdown'
application.register('dropdown', Dropdown)
